import React, { useState, useEffect } from "react";
import { ShoppingCart } from "lucide-react";
import Rating from 'react-rating';
import { FaStar, FaRegStar } from 'react-icons/fa';
import CollapsibleSection from './CollapsibleSection'
import "./ProductDetailPage.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import toast from 'react-simple-toasts';
import StoreUserReviews from "./StoreUserReviews"
import { ArrowBackIos, Search } from "@mui/icons-material";
import { fetch_product_details, updateCartV2 } from "../apiservices/ApiService";

const ProductDetailPage = () => {
  const [timeLeft, setTimeLeft] = useState({ h: 1, m: 42, s: 17 });
  const [productDetails, setProductDetails] = useState(null);
  
  const productId = localStorage.getItem("productId");

  const navigate = useNavigate();
  const [cartCount, setCartCount] = useState("0");
  const [loading, setLoading] = useState(false);

  const goBack = () => {
    navigate(-1);  // This will navigate to the previous page
  };

  // Navigate to Cart Page
  const cartPageNavigation = () => {
    const currentQueryParams = window.location.search;
    window.location.href = `/store_cart_page${currentQueryParams}`;
  };

  const handleAddToCart = async (productId, buyNow) => {
    setLoading(true);
    try {

      const response = await updateCartV2({ callingFrom: "grid", flow: "grid", productsJson: `[{"productId":"${productId}","quantity":"1"}]` });

      if (response != null && response.code == 200) {
        toast("added to cart!", 500);
        setCartCount(response.data.cart[0].cartItemCount);
        if (buyNow) {
          cartPageNavigation();
        }
      } else if (response != null && response.data != null && response.data.message != null) {
        toast(response.data.message, 500);
      }


    } catch (error) {
      alert("Failed to add product to cart.");
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        const newSeconds = prev.s - 1;
        if (newSeconds >= 0) return { ...prev, s: newSeconds };

        const newMinutes = prev.m - 1;
        if (newMinutes >= 0) return { h: prev.h, m: newMinutes, s: 59 };

        const newHours = prev.h - 1;
        if (newHours >= 0) return { h: newHours, m: 59, s: 59 };

        return { h: 0, m: 0, s: 0 };
      });
    }, 1000);
    loadVideoComponents();
    return () => clearInterval(timer);
  }, []);
  const loadVideoComponents = async () => {

    const productJson = JSON.stringify({
      productId: productId, // Jo bhi tera productId variable hoga
    });
    const response = await fetch_product_details({ productJson });
    if (response.code == 200 && response.data != null) {
      setProductDetails(response.data.product)
    }
  };

  if (productDetails === null) {
    return (
      <div></div>
    );
  }

  const settings = {
    dots: productDetails.productImageUrl != null && productDetails.productImageUrl.length > 1,
    infinite: productDetails.productImageUrl != null && productDetails.productImageUrl.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: "slick-dots", // Default class
  };

  return (
    <div style={{ width: '100%', margin: "0 auto", display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Header */}
      <header
        style={{
          background: "linear-gradient(to right, #fff 0%, rgba(255, 152, 0, 0.4) 100%)",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          position: "sticky",
          top: 0,
          zIndex: 10
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0.75rem 1rem",
          }}
        >
          {/* <img src="https://appcdn.goqii.com/storeimg/79908_1733642827.webp" onClick={goBack} style={{ objectFit: 'contain', width: '24px', height: '24px' }} /> */}
          <ArrowBackIos onClick={goBack} style={{ objectFit: 'contain', width: '24px', height: '24px', color: '#681517' }} />

          {/* Title */}
          <div
            style={{
              fontSize: '16px',
              fontWeight: '400',
              color: '#681517',
              display: "flex",
              gap: "1rem",
              // marginLeft: "px",
              whiteSpace: "nowrap", // Ensures the text doesn't wrap
              overflow: "hidden", // Hides overflow content
              textOverflow: "ellipsis", // Adds "..." at the end of the overflowed text
            }}
          >
            {productDetails.productTitle}
          </div>

          {/* Right-Aligned Icons */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              marginLeft: "auto",
            }}
          >
            {/* Search Icon */}
            <div
              style={{
                cursor: "pointer",
                color: "#681517",
              }}
            // onMouseOver={(e) => (e.target.style.color = "#1f2937")}
            // onMouseOut={(e) => (e.target.style.color = "#6b7280")}
            >
              {/* <img
                src='https://appcdn.goqii.com/storeimg/83134_1733210525.webp'
                style={{ height: "1.5rem", width: "1.5rem" }}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >

              </img> */}
              <Search fontSize="large" color="#681517" />
            </div>

            {/* Cart Icon with Count */}
            <div
              onClick={() => cartPageNavigation()}
              style={{
                position: "relative",
                cursor: "pointer",
                color: "#6b7280",
              }}
            // onMouseOver={(e) => (e.target.style.color = "#1f2937")}
            // onMouseOut={(e) => (e.target.style.color = "#6b7280")}
            >
              {/* <img
                src="https://appcdn.goqii.com/storeimg/4437_1733210653.webp"
                style={{ height: "1.5rem", width: "1.5rem" }}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >

              </img> */}
              <ShoppingCart style={{ height: "1.5rem", width: "1.5rem", color: "#681517" }} />
              {/* Cart count */}
              <div
                style={{
                  position: "absolute",
                  top: "-5px",
                  right: "-5px",
                  backgroundColor: "#FF9800",
                  color: "white",
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                  width: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* Replace 3 with your dynamic cart count */}
                {cartCount}
              </div>
            </div>
          </div>

        </div>
      </header>

      {/* Scrollable Content */}
      <div style={{ padding: "1rem", flex: 1, overflowY: "auto", paddingBottom: "80px", backgroundColor: "rgba(255, 152, 0, 0.11)" }}>
        {/* Image Gallery */}
        <div style={{ flex: 1, padding: "16px" }}>
          <Slider {...settings}>
            {productDetails.productImageUrl.map((image, index) => (
              <div key={index} style={{ position: "relative" }}>
                <img
                  src={image}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "200px",
                    margin: "0 auto",
                    display: "block",
                    objectFit: "contain",
                    borderRadius: "8px",
                  }}
                />
              </div>
            ))}
          </Slider>
        </div>

        {/* Product Info */}
        <div style={{ marginBottom: "3rem" }}>

          <h1 style={{ fontSize: "1rem", fontWeight: "bold", marginBottom: "0.5rem", color: "#681517" }}>
            {productDetails.productTitle}
          </h1>
          <div style={{ display: 'flex' }}>
            <span style={{ color: 'grey' }}>
              {productDetails.brandingText}
            </span>
            <span style={{ position: 'absolute', right: '10px', alignItems: "center" }}>
              {productDetails.customerReview ?
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Rating
                      initialRating={productDetails.customerReview.totalRatingPercentage} // Pass the rating value
                      readonly // Makes the stars non-interactive
                      emptySymbol={<FaRegStar style={{ color: '#dcdcdc' }} />}
                      fullSymbol={<FaStar style={{ color: '#ffa41b' }} />} />
                    <span style={{ marginLeft: '5px', marginTop: '5px', fontSize: "0.875rem", fontWeight: "bold", color: "#681517" }}>4.7</span>
                  </div>
                </div> : ""
              }
            </span>
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <div style={{ textDecoration: "line-through", color: "#6b7280" }}>MRP: {decodeURI(productDetails.currencySymbol)}{productDetails.actualPrice}</div>
            <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "0.5rem" }}>
              <span style={{ fontSize: "16px", fontWeight: "bold", color: '#681517' }}>Offer Price: {decodeURI(productDetails.currencySymbol)}{productDetails.finalPrice}</span>
              <span style={{ color: "#FF9800", fontSize: "0.875rem" }}>{productDetails.saveText}</span>
            </div>
            <p style={{ fontSize: "0.875rem", color: "#681517" }}>Save upto {decodeURI(productDetails.currencySymbol)}{productDetails.perItemDiscount} with GOQII cash</p>
          </div>

          <div style={{ borderTop: "1px solid #e5e7eb", paddingTop: "1rem", marginBottom: "1rem", color: "#681517" }}>
            FULFILLED BY<br />
            <img
              src={productDetails.productVendorImage}
              alt="Brand Logo"
              style={{ height: "40px" }}
            />
            <br />
            <br />
            <CollapsibleSection
              title={"PRODUCT DESCRIPTION"}
              content={productDetails.productDescription}
              expanded={true}
            />

            {productDetails.refundReturnDesc ?
              <CollapsibleSection
                title={"IS THIS RETURNABLE/REFUNDABLE"}
                content={productDetails.refundReturnDesc}
              /> : ""
            }

            {productDetails.countryOrigin ?
              <CollapsibleSection
                title={"COUNTRY ORIGIN"}
                content={productDetails.countryOrigin}
              /> : ""
            }
            {productDetails.productSpecification ?
              <CollapsibleSection
                title={"SPECIFICATION"}
                content={productDetails.productSpecification}
              /> : ""
            }
            {productDetails.productDirectionsForUse ?
              <CollapsibleSection
                title={"DIRECTION FOR USE"}
                content={productDetails.productDirectionsForUse}
              /> : ""
            }
            {productDetails.productIngredients ?
              <CollapsibleSection
                title={"INGREDIENTS"}
                content={productDetails.productIngredients}
              /> : ""
            }
            {productDetails.productInstructions ?
              <CollapsibleSection
                title={"INSTRUCTIONS"}
                content={productDetails.productInstructions}
              /> : ""
            }
            {
              productDetails.customerReview &&
              <StoreUserReviews customerReview={productDetails.customerReview} />
            }
          </div>
        </div>

        {/* Fixed Action Buttons */}
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            display: "flex",
            background: "#fff",
            boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Add to Cart Button */}
          <button
            onClick={() => handleAddToCart(productDetails.productId, false)}
            style={{
              flex: 1,
              background: "linear-gradient(to right, #fff 0%, rgba(255, 152, 0, 0.5) 100%)",
              color: "#681517",
              padding: "1rem 0", // Remove side padding
              fontSize: "1rem",
              fontWeight: "bold",
              border: "none",
              cursor: "pointer",
              textAlign: "center",
            }}
          >
            <ShoppingCart style={{ marginRight: "0.5rem", verticalAlign: "middle" }} />
            Add to Cart
          </button>

          {/* Buy Now Button */}
          <button
            onClick={() => handleAddToCart(productDetails.productId, true)}
            style={{
              flex: 1,
              background: "linear-gradient(90deg, #771615 0%, #FF9800 100%)",
              color: "#fff",
              padding: "1rem 0", // Remove side padding
              fontSize: "1rem",
              fontWeight: "bold",
              border: "none",
              cursor: "pointer",
              textAlign: "center"
            }}
          >
            Buy Now
          </button>
        </div>
      </div>

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.1)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              width: "50px",
              height: "50px",
              border: "4px solid #f3f3f3",
              borderRadius: "50%",
              borderTop: "4px solid #4CAF50",
              animation: "spin 1s linear infinite",
            }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default ProductDetailPage;
